import React from 'react'

const Headings = ({title}) => {
  return (
    <div className='Headings__container center-row-left'><span></span>{title}</div>
  )
}

export default Headings